import { ReportContext, ReportFormProps, ReportType } from './types';
import React from 'react';
import dynamic from 'next/dynamic';

// Dynamic imports to avoid circular dependencies and reduce bundle size
const JobsReportForm = dynamic(
  () => import('@/containers/Reports/components/JobsReportForm')
);
const JobDetailsReportForm = dynamic(
  () => import('@/containers/Reports/components/JobDetailsReportForm')
);

export const REPORT_REGISTRY: Record<ReportType, React.ComponentType<ReportFormProps>> = {
  [ReportType.JOBS_REPORT]: JobsReportForm,
  [ReportType.MESSAGE_DOWNLOAD]: JobDetailsReportForm,
  [ReportType.QUESTION_RESPONSES]: JobDetailsReportForm,
  [ReportType.TRACKED_LINK_CLICKS]: JobDetailsReportForm,
  [ReportType.AI_SUPPORT]: JobDetailsReportForm,
};

export const getReportComponent = (type: ReportType) => {
  return REPORT_REGISTRY[type] || null;
};

export const getReportLabel = (type: ReportType): string => {
  switch (type) {
    case ReportType.JOBS_REPORT:
      return 'Jobs Report';
    case ReportType.MESSAGE_DOWNLOAD:
      return 'Message Download';
    case ReportType.QUESTION_RESPONSES:
      return 'Question Responses Download';
    case ReportType.TRACKED_LINK_CLICKS:
      return 'Tracked Link Clicks';
    case ReportType.AI_SUPPORT:
      return 'AI Support';
    default:
      return 'Unknown Report';
  }
};

export const AVAILABLE_REPORTS: Record<ReportContext, ReportType[]> = {
  'job-list': [ReportType.JOBS_REPORT],
  'job-details': [
    ReportType.MESSAGE_DOWNLOAD,
    ReportType.QUESTION_RESPONSES,
    ReportType.TRACKED_LINK_CLICKS,
    ReportType.AI_SUPPORT,
  ],
};
